<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;">
				<s-header-top></s-header-top>
			</el-header>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>				
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/supporter' }">载体平台</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/supporterDetail' }">详情</el-breadcrumb-item>
					</el-breadcrumb>
						
					<div class="page">
						<div class="page_body">
							<div class="detail_info mar_bottom">
								<div class="detail_info_image">
									<el-image style="width: 100%; height: 100%" :src="item.image?imgPath(item.image) : '../../static/pro.jpg'" fit="contain"></el-image>
								</div>
								<div class="detail_info_mark">
									<el-row class="name mar_bottom10">
										<el-col :span="24">
											{{item.name}} 
										</el-col>
									</el-row>
									<el-row class="company mar_bottom10">
										<el-col :span="24" v-if="item.keywords&&item.keywords!= ''">
											<el-tag v-for="tag in (item.keywords||'').split(',')" :key="tag" class="tag" type="info" effect="plain" size="small">{{tag}}</el-tag>
										</el-col>
									</el-row>
									<el-row class="mar_bottom10">
										<el-col :span="24">
											地址：{{item.address}}
										</el-col>												
									</el-row>
									<el-row class="mar_bottom10">
										<el-col :span="24">
											联系电话：{{item.telephone}}
										</el-col>												
									</el-row>			
									<el-row class="buttons" type="flex">											
										<div class="call" @click="call('咨询热线',item.telephone)"><i class="el-icon-chat-dot-round"></i>咨询</div>
										<div class="save" @click="save()" v-if="!isCollect">
											<i class="el-icon-star-off"></i>
											收藏
										</div>
										<div class="save" @click="cancelColl()" v-else>
											<i class="el-icon-star-on" style="color: #ffaa00;"></i>
											已收藏
										</div>
									</el-row>
								</div>
							</div>
							<!-- <el-row class="remark  mar_bottom">
								<el-col :span="24"  class="lab_hr"><div class="lab mar_bottom10">载体领域</div></el-col>
								<el-col :span="24">{{item.area}}</el-col>
							</el-row> -->
							<el-row class="remark  mar_bottom">
								<el-col :span="24"  class="lab_hr"><div class="lab mar_bottom10">载体介绍</div></el-col>
								<el-col :span="24"><p v-html="item.info"></p></el-col>
							</el-row>
						</div>
					</div>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>	
</template>

<script>
import sHeaderTop from '@/components/header_top'
import sHeader from '@/components/header'
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import { platformDetail ,saveColl, collectionLight, cancelColl,} from '@/api';
import store from '@/store/index.js';
export default {
  name: 'supporterDetail',
  components:{
	sHeaderTop,
	sHeader,
	sFooter,
	sCopyRight
  },
  data () {
    return {
  		id: '',
  		item: null,	
		isCollect: '',
		token: false,
    }
  },
  mounted(option) {
		this.token = localStorage.getItem('token');
		(this.id = this.$route.query.id), //接受参数关键代码
			this.getPlatformDetail(this.id);
		//如果当前是登录状态，默认进来已收藏的产品 修改收藏按钮图标
		if (store.state.isLogin) {
			this.collectionLight();
		}
  },
  methods:{
	//查询详情
  	getPlatformDetail(id){
  		let _this = this
  		platformDetail({
  		  id: id
  		}).then(res=> {
  			_this.item = res.data
  		})
  	},
	//取消收藏
	cancelColl() {
		cancelColl({
			id: this.id,
			typeName: 'msg_platform'
		}).then(res => {
			this.isCollect = !this.isCollect;
			this.$forceUpdate();
			this.$message({
				message: '取消成功',
				type: 'success'
			});
		});
	},
	//收藏
	collectionLight() {
		let _this = this;
		collectionLight({
			id: this.id,
			typeName: 'msg_platform'
		}).then(res => {
			if (res.code == 1) {
				_this.isCollect = false;
			} else {
				_this.isCollect = true;
			}
		});
	},
	//收藏
	save() {
		saveColl({
			id: this.id,
			typeName: 'msg_platform'
		}).then(res => {
			if (res.code == 0) {
				this.isCollect = !this.isCollect;
				this.$message({
					message: '收藏成功',
					type: 'success'
				});
			}
		});
	},
	//打电话弹框
	call(title, phone) {
		this.$alert(phone ? phone : '暂未提供', title, {
			confirmButtonText: '确定',
			callback: action => {}
		});
	},
	//图片地址
	imgPath(oldPath){			
		return this.$imgBaseUrl + oldPath
	},
  }
}
</script>

<style lang="scss" scoped>

.page_body{
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.detail_info{
	display: flex;
	flex-direction: row;
}
.detail_info_image{
	width: 250px;
}
.detail_info_mark{
	flex: 1;
}
.detail_info_image,.detail_info_mark{
	height: 200px;
}
.tag{
	margin-right: 10px;
}
.name{
	line-height: 40px;
	margin-top: 10px;
	text-align: left;
	color: rgba(16, 16, 16, 1);
	font-size: 24px;
	font-weight: 600;
}
.mark{
	width: 100%;
	background-color: rgba(250, 250, 250, 1);
	color: rgba(16, 16, 16, 1);
	border: 1px solid rgba(187, 187, 187, 1);
}
.remark{
	width: 100%;
	>>> img{
		width:100%;
	}
}


.call,.save{
	height: 36px;
	width: 100px;
	background-color: #F5F5F5;
	border: 1px solid #BBBBBB;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	margin-right: 30px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/supporter-detail.vue